// extracted by mini-css-extract-plugin
var _1 = "ViewingApplicantPreviewSkeleton-modulerow__NwYU7 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "row" }
